module.exports = __webpack_public_path__ + "img/related.583d734.png";